<app-base-list-wrapper [baseListComponent]="this">
    <ng-template #moreButtons let-table="table">
        <span class="more-buttons-root flex flex-nowrap gap-1 items-center shrink-0">
            <!-- Action icons stay in one row (toolbar + overflow popover) -->
            <div class="flex gap-1 items-center shrink-0">
                <!-- ADD PAYMENT BUTTON -->
                <p-button
                    #addPaymentButton
                    pTooltip="{{ 'finance.add-payment' | translate }}"
                    [outlined]="true"
                    [icon]="'fa-solid fa-money-bill-wave'"
                    (onClick)="showNewPaymentDialog()"
                    [attr.data-testid]="
                        'phx-base-detail-add-payment-button-open-item-payment-combined-list-widget'
                    "
                ></p-button>

                <!-- BALANCE BUTTON -->
                <span
                    [pTooltip]="
                        balancingButton.disabled
                            ? ('finance.balancing-no-selection-or-open-sum' | translate)
                            : ''
                    "
                >
                    <p-button
                        #balancingButton
                        [disabled]="isBalancingButtonDisabled()"
                        pTooltip="{{ 'finance.balance-open-item-accounting' | translate }}"
                        [outlined]="true"
                        [icon]="'fa-solid fa-money-bill-transfer'"
                        (onClick)="showBalancingDialog()"
                        [attr.data-testid]="
                            'phx-base-detail-balancing-button-open-item-payment-combined-list-widget'
                        "
                        [outlined]="this.selectedItems().length == 0"
                    ></p-button>
                </span>

                <p-button
                    #balanceRestAmountButton
                    [disabled]="
                        openAmountOfSelectedItemsSig() == 0 || !hasProcessedInSelectedItemsSig()
                    "
                    [pTooltip]="'balancing.balance-despite-restAmount-tooltip' | translate"
                    [icon]="'fa-solid fa-coins'"
                    label=""
                    (click)="balanceRestAmount()"
                    [outlined]="balanceRestAmountButton.disabled"
                ></p-button>
            </div>

            <!-- SELECT DEBITOR/CREDITOR BUTTON -->
            <p-selectButton
                *ngIf="!noDebCredButtonSig()"
                #selectButton
                class=""
                styleClass=""
                [options]="debCredOptions"
                [ngModel]="debCredValue"
                (ngModelChange)="setDebCred($event)"
                optionLabel="label"
                optionValue="value"
                [attr.data-testid]="
                    'show-debitor-creditor-select-button-open-item-payment-combined-list-widget'
                "
            />

            <span class="grid grid-cols-3 gap-2">
                <span class="flex flex-col">
                    <label class="mr-2">{{ 'open-items.open' | translate }}</label>
                    <p-checkbox
                        class="mr-1"
                        name="group1"
                        binary="true"
                        (ngModelChange)="onOpenOrPartialChange($event)"
                        [ngModel]="isOpenOrPartialSig()"
                        [attr.data-testid]="
                            'is-open-checkbox-open-item-payment-combined-list-widget'
                        "
                    ></p-checkbox>
                </span>
                <span class="flex flex-col">
                    <label class="mr-2">{{ 'open-items.overdue' | translate }}</label>
                    <p-checkbox
                        class="mr-1"
                        name="group1"
                        binary="true"
                        (ngModelChange)="onPaymentTargetDateOverdueChange($event)"
                        [ngModel]="isPaymentTargetDateOverdueSig()"
                        [attr.data-testid]="
                            'is-payment-target-date-overdue-checkbox-open-item-payment-combined-list-widget'
                        "
                    ></p-checkbox>
                </span>
                <span class="flex flex-col">
                    <label class="mr-2">{{ 'open-items.completed' | translate }}</label>
                    <p-checkbox
                        class="mr-1"
                        name="group1"
                        binary="true"
                        (ngModelChange)="onCompletedChange($event)"
                        [ngModel]="isCompletedSig()"
                        [attr.data-testid]="
                            'is-completed-checkbox-open-item-payment-combined-list-widget'
                        "
                    ></p-checkbox>
                </span>
            </span>
            <app-generic-enum-drop-down
                [enumName]="'OpenItemPaymentCombinedFilterType'"
                [placeholder]="'open-items.filter-type' | translate"
                [value]="filterType()"
                (valueChange)="filterType.set($event)"
            ></app-generic-enum-drop-down>
            <app-phx-input-datepicker
                [ngModel]="toDate()"
                (ngModelChange)="toDate.set($event)"
                [placeholder]="'open-items.to-date' | translate"
            ></app-phx-input-datepicker>
            <span class="flex flex-col">
                <label class="mr-2">{{
                    'open-items.use-document-date-as-to-date' | translate
                }}</label>
                <p-checkbox
                    class="mr-1"
                    (onChange)="onChangeUseDocumentDateAsToDate()"
                    binary="true"
                    (ngModelChange)="useDocumentDateAsToDateSig.set(!useDocumentDateAsToDateSig())"
                    [ngModel]="useDocumentDateAsToDateSig()"
                    [attr.data-testid]="
                        'use-document-date-as-to-date-checkbox-open-item-payment-combined-list-widget'
                    "
                ></p-checkbox>
            </span>
        </span>
    </ng-template>
</app-base-list-wrapper>

<ng-template #debCredNumberFilter let-value let-filterCallback="filterCallback" pTemplate="filter">
    <app-address-drop-down
        #addressDropDown
        [(value)]="addressFilterValue"
        [showOnlyDebitors]="isDebitor"
        [showOnlyCreditors]="isCreditor"
        (valueChange)="filterPerAddress($event, filterCallback)"
    ></app-address-drop-down>
</ng-template>
